import { Provider } from '@angular/core';
import { TICKET_BCP_PROVIDERS } from './ticket-bcp/ticket-bcp.providers';
import { TICKET_NOTARY_PROVIDERS } from './ticket-notary/ticket-notary.providers';
import { TICKET_FROM_CLIENT_PROVIDERS } from './ticket-from-client/ticket-from-client.providers';
import { TICKET_CLIENT_PROVIDERS } from './ticket-client/ticket-client.providers';
import { MANAGE_INFO_CLIENT_PROVIDERS } from './manage-info-client/manage-info-client.providers';
import { MODAL_ALL_TICKETS_PROVIDERS } from './modal-all-tickets/modal-all-tickets.providers';
import { AGENDA_SIGNING_PROVIDERS } from './agenda-signing/agenda-signing.providers';
import { ATTACHMENTS_PROVIDERS } from './attachments/attachments.providers';

/**
 * Providers de los 8 features de `capabilities/` con puerto propio (`comment-history-modal`
 * no tiene). Reemplaza a `CapabilitiesModule` — los componentes ya son standalone, cada
 * consumidor los importa directo; esto solo registra los casos de uso/repositorios.
 */
export const CAPABILITIES_PROVIDERS: Provider[] = [
  ...TICKET_BCP_PROVIDERS,
  ...TICKET_NOTARY_PROVIDERS,
  ...TICKET_FROM_CLIENT_PROVIDERS,
  ...TICKET_CLIENT_PROVIDERS,
  ...MANAGE_INFO_CLIENT_PROVIDERS,
  ...MODAL_ALL_TICKETS_PROVIDERS,
  ...AGENDA_SIGNING_PROVIDERS,
  ...ATTACHMENTS_PROVIDERS,
];
